// @flow
import ErrorId from '../protocol/ErrorId';
import t from '../i18n/I18n';

const DEFAULT_MESSAGE = t('DEFAULT_ERROR_MSG');

export function getErrorMessage(err: ErrorId | Error) {
  if (!err) {
    return DEFAULT_MESSAGE;
  }
  
  if (process.env.NODE_ENV === 'production') {
    return err.errorDetails || err.message || DEFAULT_MESSAGE;
  }

  const msg = String(err.errorDetails || err.message || err || DEFAULT_MESSAGE);
  const code = err.errorKey || err.errorId || err.code;
  const prefix = code && code.trim().toUpperCase() != 'UNKNOWN' ? `[${code}] ` : '';
  return prefix + msg;
}
